/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Area_ShoulderInputs */

const en_us2_profile_editors_pain_area_shoulder = /** @type {(inputs: Profile_Editors_Pain_Area_ShoulderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoulder`)
};

const pt_br2_profile_editors_pain_area_shoulder = /** @type {(inputs: Profile_Editors_Pain_Area_ShoulderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ombro`)
};

const es_419_profile_editors_pain_area_shoulder = /** @type {(inputs: Profile_Editors_Pain_Area_ShoulderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hombro`)
};

const pt_pt2_profile_editors_pain_area_shoulder = /** @type {(inputs: Profile_Editors_Pain_Area_ShoulderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ombro`)
};

const fr_fr2_profile_editors_pain_area_shoulder = /** @type {(inputs: Profile_Editors_Pain_Area_ShoulderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Épaule`)
};

const de_de2_profile_editors_pain_area_shoulder = /** @type {(inputs: Profile_Editors_Pain_Area_ShoulderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schulter`)
};

const it_it2_profile_editors_pain_area_shoulder = /** @type {(inputs: Profile_Editors_Pain_Area_ShoulderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spalla`)
};

/**
* | output |
* | --- |
* | "Shoulder" |
*
* @param {Profile_Editors_Pain_Area_ShoulderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_area_shoulder = /** @type {((inputs?: Profile_Editors_Pain_Area_ShoulderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Area_ShoulderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_area_shoulder(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_area_shoulder(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_area_shoulder(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_area_shoulder(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_area_shoulder(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_area_shoulder(inputs)
	return en_us2_profile_editors_pain_area_shoulder(inputs)
});
export { profile_editors_pain_area_shoulder as "profile-editors.pain_area_shoulder" }